<template>
  <div>
    <div v-if="loading" style="text-align: center">
      <md-progress-spinner
        class="md-accent"
        md-mode="indeterminate"
        :md-diameter="500"
        :md-stroke="10"
      />
    </div>
    <div v-if="!loading">
      <div class="row" style="align-items: center">
        <div class="hover-cursor ml-2 hover-cursor" @click="$router.back()">
          <md-icon class=""> arrow_back </md-icon>
        </div>
        <div class="col">
          <p class="md-title mb-0">
            {{ equipamento.nome }} -
            {{
              editando ? form.descricao || form.codigoIntegracao : 'Novo Sensor'
            }}
          </p>
          <p class="md-caption mt-0" style="font-size: 1rem">
            {{ equipamento.descricao }}
          </p>
        </div>
      </div>
      <form novalidate @submit.prevent="validateUser">
        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('codigoIntegracao')">
                    <label for="codigoIntegracao"
                      >Código integração (parâmetro recebido)</label
                    >
                    <md-input
                      id="codigoIntegracao"
                      v-model="form.codigoIntegracao"
                      name="numeroIntenro"
                      :disabled="loading || somenteCalibracao"
                    />
                    <span
                      v-if="!$v.form.codigoIntegracao.required"
                      class="md-error"
                      >Codigo de integração é necessário</span
                    >
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('descricao')">
                    <label :for="`descricao${_uid}`">Descrição</label>
                    <md-input
                      :id="`descricao${_uid}`"
                      v-model="form.descricao"
                      name="descricao"
                      :disabled="loading || somenteCalibracao"
                    />
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label :for="`epanetId${_uid}`">Epanet Id</label>
                    <md-input
                      :id="`epanetId${_uid}`"
                      v-model="form.epanetId"
                      name="epanetId"
                      :disabled="loading || somenteCalibracao"
                    />
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('tipoSensor')">
                    <label for="tipoSensor">Tipo</label>
                    <md-select
                      id="tipoSensor"
                      v-model="form.tipoSensor"
                      name="tipoSensor"
                      md-dense
                      :disabled="loading || somenteCalibracao"
                    >
                      <md-option
                        v-for="tipoId in Object.keys(tipoSensor)"
                        :key="tipoId"
                        :value="tipoId"
                      >
                        {{ tipoSensor[tipoId].tipo }}
                      </md-option>
                    </md-select>
                    <span class="md-error">Tipo do sensor obrigatório</span>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('epanetSensorTipo')">
                    <label for="epanetSensorTipo">Epanet Tipo</label>
                    <md-select
                      id="epanetSensorTipo"
                      v-model="form.epanetSensorTipo"
                      name="epanetSensorTipo"
                      md-dense
                      :disabled="loading || somenteCalibracao"
                    >
                      <md-option
                        v-for="(text, id) in epanetSensorTipo"
                        :key="id"
                        :value="id"
                      >
                        {{ text }}
                      </md-option>
                    </md-select>
                    <span class="md-error">Tipo do sensor obrigatório</span>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label :for="`cota${_uid}`"
                      >Cota (Valor a ser somado para calibrar epanet)</label
                    >
                    <md-input
                      :id="`cota${_uid}`"
                      v-model="form.cota"
                      name="cota"
                      type="number"
                      :disabled="loading || somenteCalibracao"
                    />
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-switch
                    v-model="form.visibilidadeGrafico"
                    :disabled="somenteCalibracao"
                    @change="
                      () =>
                        alterarVisibilidadeGrafico(
                          sensorId,
                          form.visibilidadeGrafico
                        )
                    "
                  >
                    Exibir gráfico
                  </md-switch>
                </div>
              </div>
            </div>
            <div
              v-if="tipoSensor[form.tipoSensor].calibravel"
              class="md-layout-item md-size-50"
            >
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field
                    :class="getValidationClass('calibracao', 'tipoPino')"
                  >
                    <label :for="`calibracaoTipoPino${_uid}`">Tipo Pino</label>
                    <md-select
                      :id="`calibracaoTipoPino${_uid}`"
                      v-model.number="form.calibracao.value.tipoPino"
                      name="Média"
                      :disabled="loading"
                    >
                      <md-option
                        v-for="(text, id) in TipoPinoSensor"
                        :key="id"
                        :value="id"
                      >
                        {{ text }}
                      </md-option>
                    </md-select>
                    <span
                      v-if="!$v.form.calibracao.value.tipoPino.required"
                      class="md-error"
                      >Campo obrigatório</span
                    >
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('calibracao', 'pino')">
                    <label :for="`calibracaopino${_uid}`">Pino</label>
                    <md-input
                      :id="`calibracaopino${_uid}`"
                      v-model.number="form.calibracao.value.pino"
                      name="Pio"
                      :disabled="loading"
                    />
                    <span
                      v-if="!$v.form.calibracao.value.multiplicacao.required"
                      class="md-error"
                      >Campo obrigatório</span
                    >
                    <span
                      v-if="!$v.form.calibracao.value.multiplicacao.minValue"
                      class="md-error"
                      >Campo deve ser maior ou igual a zero</span
                    >
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('calibracao', 'soma')">
                    <label :for="`calibracaosoma${_uid}`">Soma</label>
                    <md-input
                      :id="`calibracaosoma${_uid}`"
                      v-model.number="form.calibracao.value.soma"
                      name="Soma"
                      :disabled="loading"
                    />
                    <span
                      v-if="!$v.form.calibracao.value.multiplicacao.required"
                      class="md-error"
                      >Campo obrigatório</span
                    >
                    <span
                      v-if="!$v.form.calibracao.value.multiplicacao.minValue"
                      class="md-error"
                      >Campo deve ser maior ou igual a zero</span
                    >
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field
                    :class="getValidationClass('calibracao', 'subtracao')"
                  >
                    <label :for="`calibracaosubtracao${_uid}`">Subtração</label>
                    <md-input
                      :id="`calibracaosubtracao${_uid}`"
                      v-model.number="form.calibracao.value.subtracao"
                      name="subtracao"
                      :disabled="loading"
                    />
                    <span
                      v-if="!$v.form.calibracao.value.subtracao.required"
                      class="md-error"
                      >Campo obrigatório</span
                    >
                    <span
                      v-if="!$v.form.calibracao.value.subtracao.minValue"
                      class="md-error"
                      >Campo deve ser maior ou igual a zero</span
                    >
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field
                    :class="getValidationClass('calibracao', 'multiplicacao')"
                  >
                    <label :for="`calibracaomultiplicacao${_uid}`"
                      >Multiplicação</label
                    >
                    <md-input
                      :id="`calibracaomultiplicacao${_uid}`"
                      v-model.number="form.calibracao.value.multiplicacao"
                      name="Multiplicação"
                      :disabled="loading"
                    />
                    <span
                      v-if="!$v.form.calibracao.value.multiplicacao.required"
                      class="md-error"
                      >Campo obrigatório</span
                    >
                    <span
                      v-if="!$v.form.calibracao.value.multiplicacao.minValue"
                      class="md-error"
                      >Campo deve ser maior ou igual a zero</span
                    >
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field
                    :class="getValidationClass('calibracao', 'zerarMenorQue')"
                  >
                    <label :for="`calibracaozerarMenorQue${_uid}`"
                      >Zerar menor que</label
                    >
                    <md-input
                      :id="`calibracaoZerarMenorQue${_uid}`"
                      v-model.number="form.calibracao.value.zerarMenorQue"
                      name="Zerar menor que"
                      :disabled="loading"
                    />
                    <span
                      v-if="!$v.form.calibracao.value.multiplicacao.required"
                      class="md-error"
                      >Campo obrigatório</span
                    >
                    <span
                      v-if="!$v.form.calibracao.value.multiplicacao.minValue"
                      class="md-error"
                      >Campo deve ser maior ou igual a zero</span
                    >
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('calibracao', 'media')">
                    <label :for="`calibracaomedia${_uid}`">Média</label>
                    <md-input
                      :id="`calibracaomedia${_uid}`"
                      v-model.number="form.calibracao.value.media"
                      name="Média"
                      :disabled="loading"
                    />
                    <span
                      v-if="!$v.form.calibracao.value.multiplicacao.required"
                      class="md-error"
                      >Campo obrigatório</span
                    >
                    <span
                      v-if="!$v.form.calibracao.value.multiplicacao.minValue"
                      class="md-error"
                      >Campo deve ser maior ou igual a zero</span
                    >
                  </md-field>
                </div>
              </div>
            </div>
          </div>
        </md-card-content>

        <md-card-actions>
          <router-link
            v-if="!somenteCalibracao"
            :to="{
              name: 'TipoSensorIndex',
              query: { equipamentoId: equipamentoId },
            }"
          >
            <md-button class="md-primary"> Criar tipo sensor </md-button>
          </router-link>
          <md-button
            class="md-accent"
            :disabled="loading"
            @click="() => $router.back()"
          >
            Cancelar
          </md-button>
          <md-button
            type="submit"
            class="md-raised md-primary"
            :disabled="loading"
          >
            {{ editando ? 'Editar' : 'Adicionar' }}
            Sensor
          </md-button>
        </md-card-actions>
      </form>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import auth, { roles } from '@/utils/auth'
import { EpanetSensorTipo, TipoPinoSensor, TipoSensor } from '@/utils/constants'
import http from '@/utils/http'

const defaultCalibracao = {
  status: 0,
  tipoEnvio: 0,
  atualizadoEm: '2023-09-26T12:38:41.365144Z',
  acaoEquipamentoId: '1156208191407652864',
  value: {
    pino: 0,
    soma: 0,
    subtracao: 0,
    multiplicacao: 1,
    zerarMenorQue: 0,
    media: 1,
    tipoPino: 0,
  },
}

export default {
  name: 'EquipamentoSensorForm',
  mixins: [validationMixin],
  data() {
    return {
      equipamentoId: Number,
      localId: Number,
      // If it is editing
      sensorId: Number,
      editando: false,
      equipamento: null,
      loading: false,
      form: {
        id: null,
        descricao: '',
        codigoIntegracao: null,
        tipoSensor: 1,
        epanetSensorTipo: 0,
        cota: 0,
        epanetId: null,
        calibracao: defaultCalibracao,
        visibilidadeGrafico: true,
      },
      tipoSensor: TipoSensor,
      epanetSensorTipo: EpanetSensorTipo,
      activeModalDelete: false,
    }
  },
  computed: {
    TipoPinoSensor() {
      return TipoPinoSensor
    },
    // Usuário com apenas CalibracaoEdicao só pode alterar os parâmetros de calibração
    somenteCalibracao() {
      return (
        !auth.canEquipamentoEditar() && auth.hasRole(roles.CALIBRACAO_EDICAO)
      )
    },
  },
  validations: {
    form: {
      codigoIntegracao: {
        required,
      },
      tipoSensor: {
        required,
      },
      calibracao: {
        value: {
          pino: { required, minValue: (value) => value >= 0 },
          soma: { required, minValue: (value) => value >= 0 },
          multiplicacao: { required, minValue: (value) => value >= 0 },
          subtracao: { required, minValue: (value) => value >= 0 },
          zerarMenorQue: { required, minValue: (value) => value >= 0 },
          media: { required, minValue: (value) => value >= 0 },
          tipoPino: { required },
        },
      },
    },
  },
  async beforeMount() {
    if (this.$route.params.equipamentoId && this.$route.params.localId) {
      this.equipamentoId = this.$route.params.equipamentoId
      this.localId = this.$route.params.localId

      if (this.$route.params.sensorId) {
        this.sensorId = this.$route.params.sensorId
      }

      await this.loadData(this.equipamentoId)
    }
  },
  async created() {
    const tiposSensores = (await http.get('/tiposSensores')).tiposSensores

    tiposSensores.forEach((e) => {
      this.tipoSensor[e.id] = e
    })
  },
  methods: {
    async loadData() {
      this.loading = true

      try {
        await http.get(`equipamento/${this.equipamentoId}`).then((data) => {
          this.equipamento = data.equipamento
        })

        if (this.sensorId) {
          const sensor = this.equipamento.sensores.find(
            (sensor) => sensor.id === this.sensorId
          )

          if (sensor) {
            this.setEdit(sensor)
          }
        }
      } finally {
        this.loading = false
      }
    },
    async alterarVisibilidadeGrafico(sensorId, visibilidade) {
      if (sensorId === null) {
        return
      }

      await http.put('sensor/configuracoes/visibilidade-grafico', {
        sensorId,
        visibilidade,
      })
    },
    setEdit(sensor) {
      this.editando = true
      this.form = {
        ...sensor,
        calibracao: sensor.calibracao || defaultCalibracao,
      }

      document
        .getElementsByClassName(
          'md-app-scroller md-layout-column md-flex md-theme-default md-scrollbar'
        )[0]
        .scrollTo(0, 0)
    },
    async sendEdit() {
      const result = this.somenteCalibracao
        ? await http.post('sensor/calibracao', {
            equipamentoId: this.equipamentoId,
            calibracoes: [
              {
                sensorId: this.form.id,
                calibracao: this.form.calibracao.value,
              },
            ],
          })
        : await http.put('sensor', {
            ...this.form,
            sensorId: this.form.id,
            calibracao: this.form.calibracao.value,
          })

      if (!result) {
        return
      }

      setTimeout(() => {
        this.$v.$reset()
      }, 0)

      this.$router.back()
    },
    async sendCreate() {
      const result = await http.post('sensor', {
        equipamentoCampoId: this.equipamentoId,
        sensor: {
          ...this.form,
          calibracao: this.form.calibracao.value,
        },
      })

      if (!result) {
        return
      }

      setTimeout(() => {
        this.$v.$reset()
      }, 0)

      this.$router.back()
    },
    async saveSensor() {
      this.loading = true

      if (this.editando) {
        await this.sendEdit()
      } else {
        await this.sendCreate()
      }

      this.loading = false
    },
    async validateUser() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        await this.saveSensor()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.text-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 0 !important;
  max-width: 100%;
}

.hover-cursor {
  cursor: pointer;
}
</style>
